import { createContext, useContext, useMemo, useState } from 'react';

const Context = createContext();

export const useRenameContext = () => useContext(Context);

export function Provider({ children }) {
  const [isRenaming, setRenaming] = useState(false);

  const state = useMemo(() => ({ isRenaming, setRenaming }), [isRenaming]);

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
